import { render, staticRenderFns } from "./OabProcessosFormModal.vue?vue&type=template&id=2b05fc0f&scoped=true&"
import script from "./OabProcessosFormModal.vue?vue&type=script&lang=js&"
export * from "./OabProcessosFormModal.vue?vue&type=script&lang=js&"
import style0 from "./OabProcessosFormModal.vue?vue&type=style&index=0&id=2b05fc0f&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b05fc0f",
  null
  
)

export default component.exports